var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"search-results-summary text-serif textbox-fancy border-tertiary"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.incipit)}}),_c('search-query-summary',{staticClass:"d-inline",attrs:{"search-query":_vm.searchQuery},on:{"updated":_vm.onSummaryUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }